"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclRoutes = void 0;
exports.aclRoutes = [
    {
        name: 'acl-policy.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'acl-policy.create',
        path: '/',
        method: 'POST'
    },
    {
        name: 'acl-policy.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'acl-policy.meta',
        path: '/meta',
        method: 'GET'
    },
    {
        name: 'acl-policy.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'acl-policy.delete',
        path: '/:id',
        method: 'DELETE'
    }
];
